<template>
  <div class="my-10 mx-4 lg:mx-0">
    <!-- --------------- BEGIN Page Mes Informations --------------- -->
    <div class="flex justify-center my-10">
      <ProfilePicture
        :show-edit-link="true"
        size="max-w-40 w-40 h-40"
      />
    </div>
    <div class="flex justify-center">
      <div class="border-dashed border-gray-300 border-2 rounded-lg">
        <div class="my-4 mx-8">
          <p class="text-sm italic font-medium text-gray-600">
            Nom d'utilisateur
          </p>
          <h4 class="text-indigo-600">
            {{ (datas || {}).username }}
          </h4>
        </div>
      </div>
    </div>
    <div class="my-10 w-full">
      <form autocomplete="off">
        <div
          class="grid grid-cols-12 gap-x-4 gap-y-5 xl:mx-1/5 2xl:mx-1/4 mx-10"
        >
          <input-text
            class="lg:col-span-6"
            name="firstname"
            libelle="Prénom"
            :value="(datas || {}).firstname"
            @input="
              (newValue) => {
                datas.firstname = newValue;
              }
            "
            :error="true"
            :msg-error="((errors || [])['user.firstname'] || [])[0]"
          />
          <input-text
            class="lg:col-span-6"
            name="lastname"
            libelle="Nom"
            :value="(datas || {}).lastname"
            @input="
              (newValue) => {
                datas.lastname = newValue;
              }
            "
            :error="true"
            :msg-error="((errors || [])['user.lastname'] || [])[0]"
          />
          <input-text
            class="lg:col-span-6"
            v-if="inCompany || isAdminPay"
            name="company"
            libelle="Entreprise"
            :disabled="
              ![
                constants.ROLE_ADMIN_ENTREPRISE,
                constants.ROLE_ADMIN_PAYEUR,
              ].includes(mainRole)
            "
            :value="(datas || {}).company"
            @input="
              (newValue) => {
                datas.company = newValue;
              }
            "
          />
          <input-text
            class="lg:col-span-6"
            v-if="inCompany || isAdminPay"
            name="function"
            libelle="Fonction"
            :value="(datas || {}).position"
            @input="
              (newValue) => {
                datas.position = newValue;
              }
            "
          />
          <input-text
            class="lg:col-span-6"
            v-if="isAdminPay"
            name="siret"
            libelle="N° SIRET"
            :maxlength="14"
            :value="(datas || {}).siret"
            @input="
              (newValue) => {
                datas.siret = newValue;
              }
            "
          />
          <input-text
            class="lg:col-span-6"
            v-if="isAdminPay"
            name="ape"
            libelle="Code APE"
            :value="(datas || {}).ape"
            @input="
              (newValue) => {
                datas.ape = newValue;
              }
            "
          />
          <input-text
            class="lg:col-span-6"
            name="email"
            type="email"
            libelle="Email"
            :value="(datas || {}).email"
            @input="
              (newValue) => {
                datas.email = newValue;
              }
            "
            :error="true"
            :msg-error="((errors || [])['user.email'] || [])[0]"
          />
          <input-text
            class="lg:col-span-6"
            name="phone_number"
            libelle="Téléphone"
            :error="true"
            type="tel"
            :value="(datas || {}).phone_number"
            @input="
              (newValue) => {
                datas.phone_number = newValue;
              }
            "
          />

          <input-text-area
            class="lg:col-span-full"
            size="5"
            name="address"
            libelle="Adresse postale"
            :value="(datas || {}).address"
            @input="
              (newValue) => {
                datas.address = newValue;
              }
            "
          />

          <!-- BEGIN Modify password form -->
          <password-modifier
            ref="password"
            grid="grid grid-cols-12 gap-x-4 gap-y-5"
            password-input-size="lg:col-span-6 col-span-full"
            confirm-password-input-size="lg:col-span-6 col-span-full"
            auth-password-input-size="lg:col-span-6 col-span-full"
            confirm-button-size="lg:col-span-6 col-span-full"
            :password="(datas || {}).password || ''"
            :confirm-password="(datas || {}).password_confirmation || ''"
            :auth-password="authPassword"
            @fillPassword="
              (newValue) => {
                (datas || {}).password = newValue;
              }
            "
            @fillConfirmPassword="
              (newValue) => {
                (datas || {}).password_confirmation = newValue;
              }
            "
            @fillAuthPassword="
              (newValue) => {
                authPassword = newValue;
              }
            "
            @confirmNewPassword="confirmNewPassword"
            :errors="errors"
          />
          <!-- END Modify password form -->

          <!-- BEGIN Affiliate link => !!! Not display it for the moment !!! -->
          <div
            v-if="false"
            class="col-span-full flex items-center space-x-2 relative"
          >
            <input-text
              name="affiliate_link"
              libelle="Lien d'affiliation"
              :value="affiliateLink"
              :disabled="true"
            />

            <action-button
              class="mt-5"
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-indigo-600"
              libelle="Copier"
              icon="copy"
              @clickAction="copyAffiliateLink()"
            />

            <transition
              enter-active-class="duration-300"
              enter-class="opacity-0"
              enter-to-class="opacity-100"
              leave-active-class="duration-300"
              leave-class="opacity-100"
              leave-to-class="opacity-0"
            >
              <tag
                v-if="linkCopied"
                class="absolute -right-5 bottom-10"
                libelle="lien copié"
                text-size="text-sm"
                text-font="font-light"
              />
            </transition>
          </div>
          <!-- END Affiliate link -->

          <a
            v-if="
              mainRole === constants.ROLE_ADMIN_PAYEUR &&
                user.CGV_accepted !== null
            "
            :href="
              '/cgv/' +
                user.id +
                '/conditions_generales_de_vente_acceptees_le_' +
                cgvDateFormatedFilename +
                '.pdf'
            "
            class="flex space-x-2 items-center col-span-full text-gray-600 text-base font-normal cursor-pointer"
            target="_blank"
          >
            <icon name="file-text" />
            <div>
              Conditions générales de vente acceptées le
              {{ cgvDateFormated }}
            </div>
          </a>
          <a
            v-if="
              (mainRole === constants.ROLE_BENEFICIAIRE ||
                $freeParticulier()) &&
                user.CGU_accepted !== null
            "
            :href="
              '/cgu/' +
                user.id +
                '/conditions_generales_d_utilisation_acceptees_le_' +
                cguDateFormatedFilename +
                '.pdf'
            "
            class="flex space-x-2 items-center col-span-full text-gray-600 text-base font-normal cursor-pointer"
            target="_blank"
          >
            <icon name="file-text" />
            <div>
              Conditions générales d'utilisation acceptées le
              {{ cguDateFormated }}
            </div>
          </a>
        </div>
      </form>
    </div>
    <!-- --------------- END Page Mes Informations --------------- -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import Icon from './../../components/Icon';
import ProfilePicture from './../../components/ProfilePicture.vue';
import Tag from './../../components/Tag.vue';

import InputText from './../../components/Inputs/InputText';
import InputTextArea from './../../components/Inputs/InputTextArea';
import ActionButton from './../../components/ActionButton';
import PasswordModifier from '../../components/Inputs/PasswordModifier.vue';

import Constants from './../../constants';

export default {
  name: 'AccountInformations',

  components: {
    ProfilePicture,
    Icon,
    ActionButton,
    InputText,
    InputTextArea,
    PasswordModifier,
    Tag,
  },

  data() {
    return {
      /* BEGIN datas for "mes informations" */
      accountDatas: {
        username: '',
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        password_confirmation: '',
        phone_number: '',
        address: '',
        company: '',
        position: '',
        siret: '',
        ape: '',
        role: '',
      },
      /* END datas for "mes informations" */

      authPassword: '',
      linkCopied: false,
    };
  },

  methods: {
    ...mapMutations({
      SET_ISADMINPAY: 'account/SET_ISADMINPAY',
      SET_ISREFERENT: 'account/SET_ISREFERENT',
      SET_INCOMPANY: 'account/SET_INCOMPANY',
      SET_DATAS: 'account/SET_DATAS',
    }),

    ...mapActions({
      save_infos: 'account/save_infos',
      isPayer: 'account/isPayer',
      saveNewPassword: 'account/saveNewPassword',
    }),

    confirmNewPassword() {
      this.saveNewPassword({
        authPassword: this.authPassword,
        accountDatas: this.datas,
      }).then(() => {
        if (!this.errors) {
          this.authPassword = '';
          this.datas.password = '';
          this.datas.password_confirmation = '';
          this.$refs.password.isAuthenticateAsk = false;
        }
      });

    },

    copyAffiliateLink() {
      this.linkCopied = true;
      navigator.clipboard.writeText(this.affiliateLink);
      setTimeout(() => {
        this.linkCopied = false;
      }, 1000);
    },
  },
  computed: {
    ...mapGetters({
      isAdminPay: 'account/isAdminPay',
      isReferent: 'account/isReferent',
      inCompany: 'account/inCompany',
      datas: 'account/datas',
      mainRole: 'auth/role',
      errors: 'account/errors',
      user: 'auth/user',
    }),

    constants: function () {
      return Constants;
    },

    cgvDateFormated() {
      function pad(s) {
        return s < 10 ? '0' + s : s;
      }

      let date = new Date(this.user.CGV_accepted);

      return [
        pad(date.getDate()),
        pad(date.getMonth() + 1),
        date.getFullYear(),
      ].join('/');
    },

    cgvDateFormatedFilename() {
      function pad(s) {
        return s < 10 ? '0' + s : s;
      }

      let date = new Date(this.user.CGV_accepted);

      return [
        pad(date.getDate()),
        pad(date.getMonth() + 1),
        date.getFullYear(),
      ].join('_');
    },

    cguDateFormated() {
      function pad(s) {
        return s < 10 ? '0' + s : s;
      }

      let date = new Date(this.user.CGU_accepted);

      return [
        pad(date.getDate()),
        pad(date.getMonth() + 1),
        date.getFullYear(),
      ].join('/');
    },

    cguDateFormatedFilename() {
      function pad(s) {
        return s < 10 ? '0' + s : s;
      }

      let date = new Date(this.user.CGU_accepted);

      return [
        pad(date.getDate()),
        pad(date.getMonth() + 1),
        date.getFullYear(),
      ].join('_');
    },

    affiliateLink() {
      return process.env.MIX_APP_URL + '?affiliate=' + this.user.affiliate_code;
    },
  },
};
</script>
